<template>
    <header-container>
        <template v-slot:left>
            <router-link :to="'/'" tag="div" class="logo logo-dark">Shop Logo</router-link>
        </template>
        <template v-slot:center>
            <div class="contact-block">
                <telegram-button :style_class="'dark'"></telegram-button>
                <email-button :style_class="'dark'"></email-button>
            </div>
        </template>
        <template v-slot:right>
            <div class="controls">
                <slide-button></slide-button>
                <div class="controls-user">
                    <div class="user" @click="openForm()">
                        <button class="button">
                            <user-icon size="24"></user-icon>
                            <span>Вход</span>
                        </button>
                    </div>
                    <div class="liked">
                        <button
                                class=" button"
                                :class="{'active': is_liked_open}"

                                @click="showLiked()"
                        >
                            <div class="liked-button">
                                <div class="counter">2</div>
                                <heart-icon size="24" ></heart-icon>
                            </div>
                        </button>
                        <div class="liked-items" v-if="is_liked_open">
                            <liked-products/>
                        </div>
                    </div>
                    <div class="cart">
                        <button class="cart-button button" @click="showSelected()">
                            <div class="counter">12</div>
                            <shopping-cart-icon size="24"></shopping-cart-icon>
                        </button>
                        <div class="cart-items" v-if="is_cart_open">
                            <cart/>
                        </div>
                    </div>
                </div>
            </div>
        </template>
    </header-container>
</template>

<script>
    import EmailButton from '../Buttons/EmailButton';
    import SlideButton from '../Buttons/SlideButton';
    import TelegramButton from '../Buttons/TelegramButton';
    import HeaderContainer from '../Containers/HeaderContainer';

    import { ShoppingCartIcon, HeartIcon, UserIcon } from 'vue-feather-icons';
    import LikedProducts from "../LikedProducts/LikedProducts";
    import Cart from "../Cart/Cart";

    export default {
        name: "HeaderMain",
        components: {
            Cart,
            LikedProducts, TelegramButton, EmailButton, SlideButton, HeaderContainer, ShoppingCartIcon, HeartIcon, UserIcon },
        props: {
            form_open: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                is_form_open: false,
                is_liked_open: false,
                is_cart_open: false
            }
        },
        methods: {
            openForm() {
                this.is_form_open = !this.is_form_open;
                this.$emit('toggleForm', this.is_form_open);
            },

            showLiked() {
                this.is_liked_open = !this.is_liked_open;
            },
            showSelected() {
                this.is_cart_open = !this.is_cart_open;
            }
        },
        watch: {
            form_open: {
                handler(val) {
                    this.is_form_open = val;
                }
            }
        }
    };
</script>

<style scoped lang="scss">
    .controls {
        display: flex;
        justify-content: space-between;
        align-items: center;
        height: 100%;
        width: 100%;
        &-user {
            display: flex;
            height: 100%;
            > div {
                display: flex;
                align-items: center;
                height: 100%;
                width: 75px;
                button {
                    color: #686F83;
                    font-size: 14px;
                    line-height: 21px;
                    cursor: pointer;
                    display: flex;
                }
            }
            svg {
                color: #686F83;
                margin-right: 10px;
            }
            .liked {
                justify-content: center;
                position: relative;
                &-items {
                    position: absolute;
                    top: 56px;
                    right: 19px;
                    z-index: 100;
                }
                &-button {
                    position: relative;
                    .counter {
                        right: -10px;
                    }
                }
                button {
                    height: 100%;
                    display: flex;
                    align-items: center;
                    svg {
                        margin: 0;
                    }
                    &.active {
                        background: #FCFCFC!important;
                        box-shadow: 0px 5px 10px rgba(0, 0, 0, 0.1);
                    }
                }

            }
            .counter {
                background: #FCFCFC;
                border-radius: 50%;
                color: #686F83;
                position: absolute;
                width: 18px;
                height: 18px;
                display: flex;
                align-items: center;
                justify-content: center;
                font-size: 12px;
                top: -8px;
                right: 5px;
            }
            .cart {
                background: linear-gradient(86.51deg, #7AC3C1 0%, #3FB0AB 100%);
                justify-content: center;
                position: relative;
                max-width: 56px;
                &-button {
                    position: relative;
                }

                svg {
                    color: #FCFCFC;
                }
                &-items {
                    position: absolute;
                    top: 56px;
                    right: 0;
                    z-index: 100;
                }
            }
        }

    }
</style>
